<template>
  <div class="container">
    <h3 class="mb-2 mt-3 d-none d-md-flex">My Account</h3>
    <v-row class="row">
      <v-col cols="12">
        <v-card outlined>
          <div class="pa-4">
            <v-avatar>
              <img :src="user.avatar" :alt="user.name" />
            </v-avatar>
            <h4 class="d-inline-block ml-2">{{ user.name }}</h4>
          </div>
          <v-divider class="my-3"></v-divider>
          <div class="pt-1 pl-4">
            <span class="caption">NIM</span>
            <p v-text="user.nim">-</p>
          </div>
          <v-divider class="my-3"></v-divider>
          <div class="pt-1 pl-4">
            <span class="caption">E-Mail</span>
            <p v-text="user.email">-</p>
          </div>
          <v-divider class="my-3"></v-divider>
          <div class="pt-1 pl-4">
            <span class="caption">Telepon</span>
            <p v-text="user.phone_number">-</p>
          </div>
          <v-divider class="mb-2"></v-divider>
          <div class="pt-1 pl-4">
            <span class="caption">Universitas</span>
            <p v-text="user.university">-</p>
          </div>
          <v-divider class="mb-2"></v-divider>
          <div class="pt-1 pl-4">
            <span class="caption">Fakultas</span>
            <p v-text="user.faculty">-</p>
          </div>
          <v-divider class="mb-2"></v-divider>
          <div class="ma-2">
            <v-btn
              block
              :to="{ name: 'MyAccountEdit' }"
              elevation="0"
              color="primary"
              >Ubah Profil</v-btn
            >
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-btn block :to="{ name: 'Faq' }" elevation="0" text>Bantuan</v-btn>

    <GoogleLogin
      :params="params"
      :onSuccess="onSuccess"
      :logoutButton="true"
      class="v-btn v-btn--block mt-5 v-size--default red--text"
      >Logout</GoogleLogin
    >
  </div>
</template>

<script>
import GoogleLogin from 'vue-google-login';
import Axios from 'axios';

export default {
  name: 'MyAccount',
  data() {
    return {
      params: {
        client_id: process.env.VUE_APP_GOGGLE_ID,
        ux_mode: 'redirect',
      },
      user: [],
      token: 'Bearer ' + localStorage.getItem('token'),
      message: null,
    };
  },
  components: {
    GoogleLogin,
  },
  mounted() {
    Axios.get(process.env.VUE_APP_API + 'user/', {
      headers: {
        Authorization: this.token,
      },
    })
      .then((response) => {
        this.user = response.data.data;
        // console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    onSuccess() {
      Axios.get(process.env.VUE_APP_API + 'auth/logout', {
        headers: {
          Authorization: this.token,
        },
      })
        .then((response) => {
          this.message = response.data;
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('user_id');
          localStorage.removeItem('isLogged');

          window.location.href = '/';
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped></style>
